import { CAMPAIGN_TYPES } from '../constants/campaign';

export default {
  computed: {
    campaignType() {
      const pageURL = window.location.pathname;
      return pageURL.substring(pageURL.lastIndexOf('/') + 1);
    },
    isOngoingType() {
      return this.campaignType === CAMPAIGN_TYPES.ONGOING;
    },
    isOnOffType() {
      return this.campaignType === CAMPAIGN_TYPES.ONE_OFF;
    },
    isWhatsappType() {
      return this.campaignType === CAMPAIGN_TYPES.WHATSAPP;
    },
  },
};
